import { venue } from "../data/content";
import "./MapSection.css";

const locationCards = [
  {
    label: "Egyházi szertartás",
    title: venue.ceremony.name,
    address: venue.ceremony.address,
    mapsUrl: venue.ceremony.mapsUrl,
    mapsEmbedUrl: venue.ceremony.mapsEmbedUrl,
    mapEyebrow: "Templom és parkolás",
    mapHeading: "Parkolási lehetőségek a templom körül",
    arrival: "Kérjük, érkezzetek 13:45-re, 15 perccel a szertartás előtt.",
    parking: venue.ceremony.parking,
    parkingInfoUrl: venue.ceremony.parkingInfoUrl,
    parkingMapEmbedUrl: venue.ceremony.parkingMapEmbedUrl,
    parkingOptions: venue.ceremony.parkingOptions,
    churchPosition: venue.ceremony.churchPosition
  },
  {
    label: "Polgári szertartás, vacsora és buli",
    title: venue.reception.name,
    address: venue.reception.address,
    mapsUrl: venue.reception.mapsUrl,
    mapsEmbedUrl: venue.reception.mapsEmbedUrl,
    mapEyebrow: "Polgári szertartás, vacsora és buli",
    mapHeading:
      "Érkezés · 15:45, vendégvárás · 16:15, polgári szertartás · 17:15",
    arrival:
      "A templomi program után saját autókkal megyünk Szajolba; 15:45-re érkezzetek meg a Nairamhoz.",
    parking: venue.reception.parking,
    parkingInfoUrl: null,
    parkingMapEmbedUrl: null,
    parkingOptions: null,
    churchPosition: null
  }
];

export default function MapSection(): JSX.Element {
  return (
    <section className="mapSection" id="travel">
      <div className="container mapSection__inner">
        <header className="mapSection__intro">
          <p className="mapSection__eyebrow">Helyszínek</p>
          <h2 className="mapSection__title">Hol találkozunk</h2>
          <p className="mapSection__subtitle">
            Szolnokon kezdünk, utána saját autókkal megyünk tovább Szajolba.
            Ha van szabad hely nálatok, kérjük, segítsetek annak, aki fuvar nélkül
            érkezik.
          </p>
          <a
            className="mapSection__routeLink"
            href={venue.transferMapsUrl}
            target="_blank"
            rel="noreferrer"
          >
            Útvonal a templomtól a Nairamig
          </a>
        </header>

        <ul className="mapSection__list">
          {locationCards.map((location) => (
            <li key={location.title}>
              <div className="mapSection__locationDetails">
                <p className="mapSection__label">{location.label}</p>
                <h3>{location.title}</h3>
                <p className="mapSection__detail">{location.address}</p>
                <p className="mapSection__meta">
                  <strong>Érkezés</strong>
                  {location.arrival}
                </p>
                <p className="mapSection__meta mapSection__meta--parking">
                  <strong>Parkolás</strong>
                  {location.parking ? (
                    <span>{location.parking}</span>
                  ) : (
                    <span
                      className="mapSection__parkingPlaceholder"
                      aria-hidden="true"
                    >
                      &nbsp;
                    </span>
                  )}
                </p>
                <div className="mapSection__links">
                  <a
                    className="mapSection__mapsLink"
                    href={location.mapsUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Megnyitás térképen
                  </a>
                  {location.parkingInfoUrl ? (
                    <a
                      className="mapSection__mapsLink"
                      href={location.parkingInfoUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Hivatalos parkolási tájékoztató
                    </a>
                  ) : null}
                </div>
              </div>

              <div className="mapSection__mapWrap">
                <div className="mapSection__mapHeader">
                  <p>{location.mapEyebrow}</p>
                  <h3>{location.mapHeading}</h3>
                </div>
                <div
                  className={`mapSection__mapWrapper${
                    location.parkingMapEmbedUrl ? " mapSection__mapWrapper--parking" : ""
                  }`}
                >
                  {location.parkingMapEmbedUrl &&
                  location.parkingOptions &&
                  location.churchPosition ? (
                    <div className="mapSection__parkingMap">
                      <div className="mapSection__parkingMapCanvas">
                        <iframe
                          title="A templom körüli parkolási lehetőségek térképe"
                          src={location.parkingMapEmbedUrl}
                          loading="lazy"
                        />
                        <span
                          className="mapSection__churchPin"
                          style={location.churchPosition}
                          aria-hidden="true"
                        >
                          <span>†</span>
                          Templom
                        </span>
                        {location.parkingOptions.map((option) => (
                          <span
                            className="mapSection__parkingPin"
                            style={option.position}
                            key={option.number}
                            aria-hidden="true"
                          >
                            <span>{option.number}</span>
                          </span>
                        ))}
                      </div>
                      <ol className="mapSection__parkingLegend">
                        {location.parkingOptions.map((option) => (
                          <li key={option.number}>
                            <span>{option.number}</span>
                            <a
                              href={option.mapsUrl}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <strong>{option.name}</strong>
                              <small>{option.walk} séta a templomtól</small>
                            </a>
                          </li>
                        ))}
                      </ol>
                    </div>
                  ) : (
                    <iframe
                      title={`${location.title} helyszín`}
                      src={location.mapsEmbedUrl}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
